import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { connect } from 'react-redux';
import { AssessoriaEmprenedoriaDerivacioEnum } from '../../../../../types/assessories/assessoria_emprenedoria_derivacio.d';
import useTematica from '../../../../../hooks/useTematica';
import ValidatedMultiSelect from '../../../../../components/common/Form/ValidatedMultiSelect/ValidatedMultiSelect';
import { enumToSelectOptionArray } from '../../../../../utils/enumToSelectOptionArray';
import { AssessoriaTipus } from '../../../../../types/assessories/assessoria_tipus';
import { APIError } from '../../../../../types/api/api';
import {
  Tematica,
  tematicaToSelectOption,
} from '../../../../../types/shared/tematica.d';
import { AppDispatch, RootState } from '../../../../../store/store';
import {
  selectTematiques,
  selectTematiquesErrors,
  selectTematiquesLoading,
} from '../../../../../store/ambits/selectors';
import { getTematiques } from '../../../../../store/ambits/getTematiquesModule';
import { useMountEffect } from '../../../../../hooks/useMountEffect';
import { sortArrayByKey } from '../../../../../utils/sortArrayByKey';
import { sortEnumByValue } from '../../../../../utils/sortEnumByValue';

interface AssessoriaEmprenedoriaDataFormProps {
  schema: any;
  loadTematiques: (payload: AssessoriaTipus) => void;
  tematiquesServerErrors: APIError | null;
  tematiquesLoading: boolean;
  tematiques: Tematica[];
}

const AssessoriaEmprenedoriaDataForm = ({
  schema,
  tematiques,
  loadTematiques,
}: AssessoriaEmprenedoriaDataFormProps) => {
  const {
    register,
    formState: { errors },
    control,
  } = useFormContext();

  useMountEffect(() => loadTematiques('emprenedoria'));

  const {
    tematiquesPlaceholder,
    subTematiquesPlaceholder,
    handleTematicaChange,
    groupedSubTematiques,
  } = useTematica();

  return (
    <>
      <ValidatedMultiSelect
        schema={schema}
        label="Temàtica"
        errors={errors}
        placeholder={tematiquesPlaceholder}
        select={{
          ...register('tematica_id'),
        }}
        onChange={handleTematicaChange}
        options={sortArrayByKey(tematiques, 'name').map(tematicaToSelectOption)}
        control={control}
        controller={Controller}
      />
      <ValidatedMultiSelect
        schema={schema}
        label="Subtemàtica"
        errors={errors}
        placeholder={subTematiquesPlaceholder}
        select={{
          ...register('subtematica_id'),
        }}
        options={groupedSubTematiques}
        control={control}
        controller={Controller}
      />
      <ValidatedMultiSelect
        schema={schema}
        label="Derivació?"
        errors={errors}
        placeholder="Selecciona si és una derivació"
        select={{
          ...register('derivacio'),
        }}
        options={enumToSelectOptionArray(
          sortEnumByValue(AssessoriaEmprenedoriaDerivacioEnum),
        )}
        control={control}
        controller={Controller}
      />
    </>
  );
};

export default connect(
  (state: RootState) => ({
    tematiques: selectTematiques(state),
    tematiquesServerErrors: selectTematiquesErrors(state),
    tematiquesLoading: selectTematiquesLoading(state),
  }),
  (dispatch: AppDispatch) => ({
    loadTematiques: (payload: string) => {
      dispatch(getTematiques(payload));
    },
  }),
)(AssessoriaEmprenedoriaDataForm);
